import React, {FormEvent, useState} from 'react';
import cn from 'classnames';

import {BottomSheet} from 'react-spring-bottom-sheet';
import useAddComments from '../../../../services/hookService/postComment/useAddComment';

const AddCommentsBottomSheet = ({
  guid,
  openAddPoints,
  title,
  setOpenAddPoints,
  refetchAllComments,
}: {
  guid?: string;
  title: string;
  openAddPoints: boolean;
  setOpenAddPoints: React.Dispatch<React.SetStateAction<boolean>>;
  refetchAllComments: () => void;
}) => {
  const [areaText, setAreaText] = useState('');
  const [rate, setRate] = useState(0);

  const refetchHandler = () => {
    refetchAllComments();
    setOpenAddPoints(false);
  };
  const {mutate} = useAddComments(refetchHandler);

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (guid) {
      const payload: IAddComments = {
        text: areaText,
        store: guid,
        rate: rate,
      };
      mutate(payload);
    }
  };

  return (
    <BottomSheet
      onDismiss={() => setOpenAddPoints(false)}
      open={openAddPoints}
      blocking={true}
      snapPoints={({minHeight, maxHeight}) => [minHeight, maxHeight / 0.8]}
      className="transition ease-in-out delay-250 "
    >
      <div className="pt-2 pb-3 ">
        <div className="flex justify-between px-3">
          <div>
            <span className="font-Medium text-md">دیدگاه شما در مورد </span>
            <span className="font-bold text-md">{title}</span>
          </div>
          <i
            className="icon-nameClose-remove text-xl"
            onClick={() => {
              setOpenAddPoints(false);
              setAreaText('');
              setRate(1);
            }}
          />
        </div>

        <div className="flex justify-between  px-3">
          <div className=" mt-3">
            <p className="text-md">ثبت امتیاز</p>
          </div>
          <div className="flex gap-1 flex-row-reverse mt-8">
            {[1, 2, 3, 4, 5].map((item, index) => (
              <i
                key={index}
                className={cn('text-xxl', {
                  'icon-nameStar !text-warning-500': index + 1 <= rate,
                  'icon-namestar': index + 1 > rate,
                })}
                onClick={() => setRate(index + 1)}
              ></i>
            ))}
          </div>
        </div>
        <form className="flex flex-col px-3" onSubmit={handleSubmit}>
          <label className="text-sm mb-2 mt-[20px]">متن دیدگاه</label>
          <textarea
            className="h-40 border rounded outline-none border-gray-300 p-2 text-md mb-4"
            placeholder="دیدگاه خود را برای ما بنویسید..."
            onChange={e => {
              setAreaText(e.target.value);
            }}
            value={areaText}
          />
          <button
            className={cn(
              'flex justify-center items-center w-full rounded text-white py-2.5 bg-farm-shop-500',
              {'!bg-farm-shop-200': rate === 0},
            )}
            type="submit"
            disabled={rate === 0}
          >
            ثبت دیدگاه
          </button>
        </form>
      </div>
    </BottomSheet>
  );
};

export default AddCommentsBottomSheet;
